module.exports = __webpack_public_path__ + "img/icn_error.7684927e.svg";